import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Tax } from '../models/tax';
import { Observable } from 'rxjs';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';

@Injectable({
  providedIn: 'root'
})
export class TaxService {

  private itemDoc: AngularFirestoreDocument<Tax>;
  private item: Observable<Tax>;

  constructor(private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }

  select() {
        return this.db.collection<Tax>('sbccv_taxs', ref => ref.orderBy('name', 'asc')).snapshotChanges();            
  }

  selectById(id) {
    this.itemDoc = this.db.doc<Tax>('sbccv_taxs/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  getById(id){
    return this.db.doc<Tax>('sbccv_taxs/' + id)
    .get();
  }

  insert(entity: Tax) {
    delete entity.id;
    return this.db.collection('sbccv_taxs').add(Object.assign({}, entity));
  }

  update(entity: Tax) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_taxs').doc(id).set(Object.assign({}, entity));
  }

  delete(entity_id: any) {
    return this.db.collection('sbccv_taxs').doc(entity_id).delete();
  }

  makeMsgError(errorsCode) {
    let msgError: string
    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }

}


